<template>
  <div>
    <div class="search-form">
      <div class="search-form-left">
        <div class="form">
          <a-form-model
            :model="form"
            layout="inline"
          >
            <a-form-model-item
              label="姓名："
              prop="userName"
            >
              <a-input
                v-model="form.userName"
                :value="form.userName"
                placeholder="请输入姓名"
                allow-clear
              />
            </a-form-model-item>
            <a-form-model-item
              label="角色:"
              prop="roleType"
            >
              <a-select
                v-model="form.roleType"
                :value="form.roleType"
                placeholder="请选择角色"
                allow-clear
              >
                <a-select-option
                  v-for="item in roleOptions"
                  :key="item.roleType"
                >
                  {{ item.roleName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-form-model>
        </div>

        <div class="ant-btns-mrright">
          <TableActions
            :actions="headerActions"
            @checkResource="checkResource"
          />
        </div>
      </div>
      <div class="search-form-right">
        <TableActions
          :actions="addActions"
          @add="addUserInfo"
          @exportResource="exportUsers"
        />
      </div>
    </div>

    <div class="table">
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pagination"
        style="padding: 16px 0; background-color: #fff;"
        :row-key="(item, index) => index"
        @change="handleTableChange"
      >
        <span
          slot="actions"
          slot-scope="text, record"
        >
          <TableActions
            :actions="tableActions"
            :record="record"
            @edit="editProduct(record)"
            @delete="deleteRecord(record)"
          />
        </span>
      </a-table>
    </div>
    <EditUserManage
      :init-data="initData"
      :dialog-title="dialogTitle"
      :visible="modalVisible"
      :base-options="baseOptions"
      :permission-names="permissionNames"
      :loading="confirmLoading"
      :action-type="actionType"
      @cancel="handleCancel"
      @ok="handleOk"
    />
  </div>
</template>

<script>
import { queryUsers, queryPermissions, deleteUser, exportUsers } from '@/api/userManage.js'
import EditUserManage from './EditUserManage.vue'
import {
  queryBases
} from '@/api/common.js'
import { excelDown } from '@/utils/utils.js'
import { pagination } from '@/constants/tableSetting'

const columns = [
  {
    title: '姓名',
    dataIndex: 'fullName',
    key: 'fullName'
  },
  {
    title: '手机号',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: '邮箱前缀',
    dataIndex: 'nickname',
    key: 'nickname'
  },
  {
    title: '角色',
    dataIndex: 'roleName',
    key: 'roleName'
  },
  {
    title: '基地权限',
    dataIndex: 'baseList',
    key: 'baseList'
  },
  {
    title: '操作权限',
    dataIndex: 'operatorPermissionList',
    key: 'operatorPermissionList'
  },
  {
    title: '操作',
    dataIndex: 'actions',
    key: 'actions',
    scopedSlots: { customRender: 'actions' }
  }
]

const addActions = [{
  title: '添加用户',
  type: 'primary',
  action: 'add',
  apis: ['@baseInfo/Add_Base']
},
{
  title: '导出',
  type: 'primary',
  action: 'exportResource',
  ghost: true,
  apis: ['@baseInfo/Export_Bases']
}]

const headerActions = [
  {
    title: '查询',
    type: 'primary',
    action: 'checkResource'
  }
]

const tableActions = [
  {
    title: '编辑',
    type: 'link',
    action: 'edit',
    apis: ['@baseInfo/Add_Base']
  },
  {
    title: '删除',
    type: 'link',
    action: 'delete',
    apis: ['@baseInfo/Add_Base']
  }
]
export default {
  components: {
    EditUserManage
    // CheckChangeRecords
  },
  data () {
    return {
      headerActions,
      columns,
      dataSource: [],
      innerDataSource: [],
      loading: false,
      pagination,
      baseId: 0,
      roleOptions: [{ roleType: 1, roleName: '管理员' }, { roleType: 2, roleName: '普通用户' }],
      tableActions,
      addActions,
      modalVisible: false,
      confirmLoading: false,
      initData: null,
      initRecords: null,
      dialogTitle: null,
      form: {
      },
      baseOptions: [],
      permissionNames: [],
      actionType: null
    }
  },
  created () {
    this.fetchData()
    this.fetchSearchOptions()
  },
  methods: {
    excelDown,
    async fetchSearchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
      await queryPermissions({
        roleType: '1'
      }).then((data) => {
        this.permissionNames = data
      })
    },
    checkResource () {
      this.pagination.current = 1
      this.fetchData()
    },
    // 异步获取数据
    async fetchData () {
      this.loading = true
      await queryUsers({
        pageIndex: this.pagination.current,
        pageSize: this.pagination.pageSize,
        roleType: this.form.roleType,
        userName: this.form.userName
      }).then((data) => {
        this.dataSource = data.result ? data.result : []
        this.pagination.total = data.totalRecords
      })
      this.loading = false
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination = { ...this.pagination, ...pagination }
      this.fetchData()// 获取表格数据的接口
    },
    editProduct (record) {
      this.initData = record
      this.dialogTitle = '编辑用户'
      this.modalVisible = true
      this.actionType = '0'
    },
    addUserInfo () {
      this.initData = {
        baseName: '',
        contractAmount: '',
        operateYear: '',
        baseIds: [],
        operatorPermissionIdList: [1]
      }
      this.modalVisible = true
      this.dialogTitle = '添加用户'
      this.actionType = '1'
    },
    deleteRecord (record) {
      this.$confirm({
        title: '确定删除该条记录吗？',
        okText: '确认删除',
        cancelText: '取消',
        onOk: async () => {
          await deleteUser({
            userId: record.userId
          }).then((data) => {
            this.$message.success('删除成功!')
            this.fetchData()
          })
        }
      })
    },
    handleCancel () {
      this.modalVisible = false
    },
    handleOk () {
      this.handleCancel()
      this.fetchData()
    },
    handleChange (value) {
      this.form.time = value
    },
    async exportUsers () {
      await exportUsers({
        roleType: this.form.roleType,
        userName: this.form.userName
      }).then((data) => {
        this.excelDown(data, '用户信息')
      })
    }
  }

}
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 16px;
}
</style>
